module.exports = __webpack_public_path__ + "static/staten-island-cover-image-124dde69a7fb7599b9f984f59b4926b0.jpg";